import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'
import state from './state'
import creatLogger from 'vuex/dist/logger'
import VuexPersist from 'vuex-persist'
Vue.use(Vuex)
const vuexSession = new VuexPersist({
  storage: window.sessionStorage
})
const debug = process.env.NODE_ENV !== 'production';
export default new Vuex.Store({
  actions,
  getters,
  state,
  mutations,
  strict: debug,
  // plugins: debug ? [creatLogger()] : [],
  plugins: [vuexSession.plugin]
})
